// @flow
import * as React from 'react';
import { Tabs } from 'antd';
import Screen from '../../Components/Screen';

import Initializing from './Components/Initializing';
import SupplierModal from '../../Modals/Supplier';
import SupplierItemModal from '../../Modals/SupplierItem';

import Breadcrumbs from './Components/Breadcrumbs';
import Header from './Components/Header';
import CatalogItemsTable from './Components/CatalogItemsTable';

const { TabPane } = Tabs;

type Props = {
  supplier: null|Object,
  showSupplierModal: boolean,
  showSupplierItemModal: boolean,
  supplierItemForEdit: null|Object,

  componentDidMount: (props: any) => void,
  componentWillUnmount: () => void,
  onClickEditSupplier: () => void,
  onCloseSupplierModal: () => void,
  didUpdateSupplier: () => void,
  didDeleteSupplier: () => void,
  onClickNewSupplierItem: () => void,
  onClickEditSupplierItem: (item: Object) => void,
  onCloseSupplierItemModal: () => void,
  didCreateSupplierItem: () => void,
  didUpdateSupplierItem: () => void,
  didDeleteSupplierItem: () => void,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount(this.props);

  componentWillUnmount = () => this.props.componentWillUnmount();

  render() {
    const {
      supplier,
      showSupplierModal,
      showSupplierItemModal,
      supplierItemForEdit,

      onClickEditSupplier,
      onCloseSupplierModal,
      didUpdateSupplier,
      didDeleteSupplier,
      onClickNewSupplierItem,
      onClickEditSupplierItem,
      onCloseSupplierItemModal,
      didCreateSupplierItem,
      didUpdateSupplierItem,
      didDeleteSupplierItem,
    } = this.props;

    if (!supplier) return <Initializing />

    return (

      <Screen>

        <Breadcrumbs
          supplier={supplier}
        />

        <Header
          supplier={supplier}
          onClickEditSupplier={onClickEditSupplier}
        />

        <Tabs defaultActiveKey="catalog" className="p-t-10" animated={false}>
          <TabPane tab="CATALOG ITEMS" key="catalog">
            <CatalogItemsTable
              supplier={supplier}
              onClickNewSupplierItem={onClickNewSupplierItem}
              onClickEditSupplierItem={onClickEditSupplierItem}
            />
          </TabPane>
        </Tabs>

        {showSupplierModal && (
          <SupplierModal
            onClose={onCloseSupplierModal}
            didUpdate={didUpdateSupplier}
            didDelete={didDeleteSupplier}
            supplier={supplier}
          />
        )}

        {showSupplierItemModal && (
          <SupplierItemModal
            onClose={onCloseSupplierItemModal}
            didCreate={didCreateSupplierItem}
            didUpdate={didUpdateSupplierItem}
            didDelete={didDeleteSupplierItem}
            supplierItem={supplierItemForEdit}
            supplierId={supplier.id}
          />
        )}

      </Screen>

    )
  };
}
